import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGlobalState } from 'state'
import * as api from 'common/api'


export const ContinueSheet = () => {
  const state = useGlobalState()
  const navigate = useNavigate()
  const { id } = useParams()

  React.useEffect(() => {
    load()
  }, [])

  const load = async () => {
    const res = await api.get(`/scoresheet/${id}`)
    if (res && res.answers) {
      state.app.setAnswers(res.answers)
      navigate('/0')
    } else {
      state.app.setAnswers({})
      navigate('/')
    }
  }

  return (
    <></>
  )
}
